// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4316 ? "ad2866b8" : chunkId) + "." + {"1177":"0b85d03473e54808","4316":"d85b767868b3371e","4548":"35d7c5c0f80967c6","5268":"489cecef701ce154"}[chunkId] + ".js";
};